import * as React from 'react';
import { twMerge } from 'tailwind-merge';
import { GoogleMark } from './GoogleMark';

// Google sign-in (https://developers.google.com/identity/branding-guidelines)
type GoogleButtonLabel = 'Sign in with Google' | 'Sign up with Google' | 'Continue with Google';

const THEMES = {
  dark: 'bg-[#131314] border-[#8E918F] text-[#E3E3E3]',
  light: 'bg-[#FFFFFF] border-[#747775] text-[#1F1F1F]',
  neutral: 'bg-[#F2F2F2] border-transparent text-[#1F1F1F]',
} as const;

interface GoogleSignInButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, 'children'> {
  label?: GoogleButtonLabel;
  theme?: keyof typeof THEMES;
}

export const GoogleSignInButton = React.forwardRef<HTMLButtonElement, GoogleSignInButtonProps>(
  ({ label = 'Continue with Google', theme = 'dark', className, ...rest }, ref) => {
    return (
      <button
        ref={ref}
        type="button"
        className={twMerge(
          'group relative flex h-10 cursor-pointer items-center overflow-hidden rounded-[4px] border pl-3 text-sm leading-5 font-medium',
          THEMES[theme],
          className,
        )}
        {...rest}
      >
        <span className="pointer-events-none absolute inset-0 bg-current opacity-0 transition-opacity duration-[140ms] group-hover:opacity-[0.08]" />
        <GoogleMark />
        <span className="pr-3 pl-[10px]">{label}</span>
      </button>
    );
  },
);
GoogleSignInButton.displayName = 'GoogleSignInButton';
